import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-475537c2")
const _hoisted_1 = { class: "title-1 center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "center padding"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "projects"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_project = _resolveComponent("card-project")!
  const _component_add_project = _resolveComponent("add-project")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { class: "view-projects" }, {
    default: _withCtx(() => [
      _createElementVNode("dig-ui-title", _hoisted_1, [
        (_ctx.isSuperadmin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('allProjects')), 1))
          : _createCommentVNode("", true),
        (!_ctx.isSuperadmin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('myProjects')), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createBlock(_component_card_project, {
                key: project.id,
                project: project
              }, null, 8, ["project"]))
            }), 128)),
            (_ctx.isSuperadmin)
              ? (_openBlock(), _createBlock(_component_add_project, {
                  key: 0,
                  ref: "addProjectEl",
                  background: true,
                  onAdd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addProject($event)))
                }, null, 512))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}